export const LS_IS_JUST_SIGNED_IN_VALUE = '1';
export const LS_IS_JUST_SIGNED_IN_NAME = 'justSignedIn';

export const GA4_CONTEXT_QUERY_KEY = ['ga4Context'] as const;
export const GOOGLE_ADS_ATTRIBUTION_QUERY_KEY = ['googleAdsAttribution'] as const;
export const LINKEDIN_ATTRIBUTION_QUERY_KEY = ['linkedInAttribution'] as const;
